

















import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
// @ts-ignore
import { VideoContainer, Video } from '@/models/ResponsiveVideo';
import ResponsiveVideos from './ResponsiveVideos.vue';

@Component({
    components: {
        ResponsiveVideos
    }
})
export default class ResponsiveVideoImage extends Vue {
    protected landscapeOrientation: boolean = true;
    protected elementSizeRatio: boolean = true;

    protected videos: string;
    protected images: string = '';
    protected link: string;

    protected videoAutoplay: string;
    protected videoPreload: string;
    protected videoLoop: string;
    protected videoMuted: string;

    protected imageThumb: string;
    protected imageTextClass: string;
    protected imageTitle: string;
    protected imageText: string;

    protected hasVideo: boolean = false;
    protected showVideo: boolean = false;
    protected showImage: boolean = false;
    protected showLink: boolean = false;
    protected showText: boolean = true;

    constructor() {
        super();

        this.videos = this.$attrs['data-video'];
        this.images = this.$attrs['data-image'];
        this.link = this.$attrs['data-link'];

        this.videoAutoplay = this.$attrs['data-video-autoplay'];
        this.videoPreload = this.$attrs['data-video-preload'];
        this.videoLoop = this.$attrs['data-video-loop'];
        this.videoMuted = this.$attrs['data-video-muted'];

        this.imageThumb = this.$attrs['data-image-thumb'];
        this.imageTextClass = this.$attrs['data-image-textclass'];
        this.imageTitle = this.$attrs['data-image-title'];
        this.imageText = this.$attrs['data-image-text'];
    }

    mounted() {
        this.initialize();
    }

    initialize() {
        if (this.videos !== null && this.videos !== 'null') {
            this.hasVideo = true;
            this.showVideo = true;

            if (this.images !== '' && this.images !== undefined) {
                this.showImage = true;
                this.showVideo = false;
            }
        } else if (this.images !== '' && this.images !== undefined) {
            this.showImage = true;
            this.showVideo = false;

            if (this.link !== '') {
                this.showLink = true;
            }
        }
    }

    playVideo() {
        if (this.hasVideo) {
            this.videoAutoplay = 'autoplay';
            this.showVideo = true;
            this.showImage = false;
            this.showText = false;
        } else if (this.link !== null && this.link !== undefined && this.link !== '') {
            window.open(this.link, '_blank');
        }
    }

    // @ts-ignore
    stopVideo() {}
}
